module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/agrigento.f2091a84ad4409eb110827e23caf8429.jpg";